import { render, staticRenderFns } from "./performance-dev-plan-details.vue?vue&type=template&id=8cbfebd4"
import script from "./performance-dev-plan-details.vue?vue&type=script&lang=js"
export * from "./performance-dev-plan-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports